<template>
  <v-container fluid>
    <v-layout column>
      <v-layout row align-center> <!-- row of filters and button -->
        <v-layout column>
          <v-layout row>
            <v-flex shrink class="mr-2">
              <v-select
                label="My Shifts / Available Shifts"
                :items="statusFilters"
                v-model="selectedStatusFilter"
                clearable
              ></v-select>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-select
                label="Position"
                :items="positionFilters"
                item-text="name"
                item-value="id"
                v-model="selectedPositionFilter"
                :loading="positionsLoading"
                :disabled="positionsLoading"
                clearable
              ></v-select>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-autocomplete
                label="Location"
                :items="locationFilters"
                item-text="name"
                item-value="id"
                v-model="selectedLocationFilter"
                :loading="locationsLoading"
                :disabled="locationsLoading"
                clearable
              ></v-autocomplete>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-switch
                v-model="selectedTradeFilter"
                label="View Trades Only"
              ></v-switch>
            </v-flex>
          </v-layout>
          <!-- <v-layout row>
            <v-flex shrink class="mr-2">
              <v-select
                label="Bonus"
                :items="bonusFilterOptions"
                v-model="selectedbonusFilter"
                clearable
              ></v-select>
            </v-flex>
          </v-layout> -->
        </v-layout>
        <v-layout row>
          <v-btn @click="reGetRecords" color="primary">
            Update
          </v-btn>
        </v-layout>
      </v-layout>

      <v-divider />

      <FilterPresets :currentQuery="formattedQuery" @updateFilters="updateFilters" />

      <v-layout align-center justify-space-between class="mb-2">
        <v-flex shrink>
          <a href="#" @click.prevent="goToList">Switch To List View</a>
          <SetDefaultViewButton view="month" class="ml-3" />
        </v-flex>
      </v-layout>

      <v-layout row justify-space-between align-center class="mb-2">
        <v-flex xs3>
          <h2 class="headline mb-2">{{ currentlyViewedCalendar }}</h2>
        </v-flex>

        <v-flex xs3>
          <v-layout row justify-space-around align-center>
            <v-flex shrink>
              <v-btn small @click="goMonthBack">
                <v-icon small>
                  keyboard_arrow_left
                </v-icon>
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn @click="goToToday">
                Today
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn small @click="goMonthForward">
                <v-icon small>
                  keyboard_arrow_right
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs3>
          <v-spacer />
        </v-flex>
      </v-layout>

      <v-flex v-if="shiftQueryPending">
        <v-progress-linear indeterminate>
        </v-progress-linear>
      </v-flex>

      <v-flex v-else>
        <v-sheet height="700">
          <v-calendar
            ref="calendar"
            class="vss-calendar"
            v-model="startDate"
            :end="endDate"
            :now="today"
            type="month"
            v-on:click:date="changeToDayView"
          >
            <template slot="day" slot-scope="{ date }">
              <div v-bind:class="{'employee-has-shifts':(employeeHasShift(date))}">
                <span class="shift-overflow-count">
                  <v-chip
                    small
                    v-if="shiftCountOnDate(date) > 1"
                    class="grey--text text--darken-2"
                  >
                    {{ shiftCountOnDate(date) }} shifts
                  </v-chip>
                </span>

                <template v-for="shift in shiftsOnDate(date).assigned">
                  <shiftOnMonth :shift="shift" :user="user"/>
                </template>
                <template v-for="shift in shiftsOnDate(date).coordinated">
                  <shiftOnMonth :shift="shift" :user="user"/>
                </template>
                <template v-for="shift in shiftsOnDate(date).trade">
                  <shiftOnMonth :shift="shift" :user="user"/>
                </template>
                <template v-for="shift in shiftsOnDate(date).available">
                  <shiftOnMonth :shift="shift" :user="user"/>
                </template>

                <template v-for="event in eventsOnDate(date)">
                  <eventOnMonth :key="`evt-${event.event_id}`" :event="event"/>
                </template>

                </div>
              </template>

          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import shiftOnMonth from '@/components/calendar/shiftOnMonth.vue'
import eventOnMonth from '@/components/calendar/eventOnMonth.vue'
import inviteApi from '@/api/invites'
import collectionApi from '@/api/collections'
import FilterPresets from '@/components/calendar/filter-presets.vue'
import SetDefaultViewButton from '@/components/calendar/set-default-view-button.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    shiftOnMonth,
    eventOnMonth,
    FilterPresets,
    SetDefaultViewButton,
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    currentlyViewedCalendar: function () {
      return this.$moment(this.startDate).format("MMMM, YYYY")
    },
    formattedQuery: function () {
      if (this.selectedStatusFilter == 'assigned' || this.selectedStatusFilter == 'employee-all') {
        this.selectedEmployeeFilter = this.user.id
      } else {
        this.selectedEmployeeFilter = null
      }

      return {
        startDate: this.startDate,
        endDate: this.endDate,
        statusFilter: this.selectedStatusFilter,
        positionFilter: this.selectedPositionFilter,
        locationFilter: this.selectedLocationFilter,
        employeeFilter: this.selectedEmployeeFilter,
        // bonusFilter: this.selectedbonusFilter,
        tradeFilter: this.selectedTradeFilter
      }
    },
    firstVisibleDate: function () {
      return this.$refs.calendar.$children[0].days[0].date
    },
    lastVisibleDate: function () {
      return this.$refs.calendar.$children[0].days.slice().pop().date
    },
  },
  methods: {
    employeeHasShift: function (date) {
      const viewingEmployeeId = this.user.id
      const shiftsThisDay = this.shifts.filter(s => this.$moment(s.startDatetime).isSame(date, 'day') )

      return shiftsThisDay.find(s => s.userId == viewingEmployeeId)
    },

    goToList: function () {
      this.$router.push({
        name: 'calendar',
        query: this.formattedQuery
      })
    },

    updateFilters(e) {
      this.selectedStatusFilter = e['statusFilter']
      this.selectedPositionFilter = e['positionFilter']
      this.selectedLocationFilter = e['locationFilter']
      this.selectedEmployeeFilter = e['employeeFilter']
      this.selectedbonusFilter = e['bonusFilter']
      this.selectedTradeFilter = e['tradeFilter']

      this.reGetRecords()
    },

    goToToday: function () {
      this.startDate = this.beginningOfCurrentMonth
      this.endDate = this.endOfCurrentMonth
      this.reGetRecords()
    },
    goMonthBack: function () {
      let newStart = this.$moment(this.startDate)
        .subtract(1, 'month')
        .format("YYYY-MM-DD")
      let newEnd = this.$moment(this.endDate)
        .subtract(1, 'month')
        .format("YYYY-MM-DD")
      this.startDate = newStart
      this.endDate = newEnd
      this.reGetRecords()
      this.$refs.calendar.prev()
    },
    goMonthForward: function () {
      let newStart = this.$moment(this.startDate)
        .add(1, 'month')
        .format("YYYY-MM-DD")
      let newEnd = this.$moment(this.endDate)
        .add(1, 'month')
        .format("YYYY-MM-DD")
      this.startDate = newStart
      this.endDate = newEnd
      this.reGetRecords()
      this.$refs.calendar.next()
    },

    dateFormatted: function (date) {
      return this.$moment(date).format("YYYY-MM-DD")
    },

    changeToDayView: function (date) {
      let query = {
        ...this.formattedQuery,
        startDate: date.date,
        endDate: date.date,
      }
      this.$router.push({
        name: 'calendar',
        query: query
      })
    },

    reGetRecords: function () {
      this.$router.push({
        name: 'month',
        query: this.formattedQuery
      })
    },


    // this should run through this.shifts _once_ and create an object with
    // date-indexed shifts so that future lookups only have to go here 
    // (rather than filtering through the entire this.shifts each time)
    // example:
    // {
    //   "10-31": [ { shift }, { shift }, ... ],
    //   "11-1" : [ { shift } ... ],
    //   ...
    // }
    shiftsByDate: function () {
      this.shifts.map((s) => {
        // get date as a string:
        let key = this.$moment(s.startDatetime).format("MM-DD")

        if (!this.dateMap.hasOwnProperty(key)) {
          // initialize this date to an empty array if this is the first time
          // we're seeing this date
          this.dateMap[key] = []
        }
        // otherwise, add this shift to the date key's array
        this.dateMap[key].push(s)
      })
    },

    getShifts: function () {
      // Need to widen the search (but not the query in the URL) to account
      // for visible dates outside this month in the calendar view
      let widerStart = this.$moment(this.formattedQuery.startDate)
        .subtract(6, 'days')
        .format('YYYY-MM-DD')
      let widerEnd = this.$moment(this.formattedQuery.endDate)
        .add(6, 'days')
        .format('YYYY-MM-DD')

      let params = {
        ...this.formattedQuery,
        startDate: widerStart,
        endDate: widerEnd
      }

      this.shiftQueryPending = true
      this.$store.dispatch('shifts/getList', params)
      .then(res => {
        this.queryTotal = res.total
        this.shifts = res.shifts
        this.shiftsByDate() // build local dateMap
      })
      .finally(res => {
        this.shiftQueryPending = false
      })

      inviteApi.getMineInRange({ from: widerStart, to: widerEnd }, (events) => {
        this.events = events
      })

    },
    setUp: function () {
      this.startDate = this.$route.query.startDate || this.startDate
      this.endDate = this.$route.query.endDate || this.endDate
      this.selectedStatusFilter = this.$route.query.statusFilter || this.selectedStatusFilter
      this.selectedPositionFilter = parseInt(this.$route.query.positionFilter) || this.selectedPositionFilter
      this.selectedLocationFilter = parseInt(this.$route.query.locationFilter) || this.selectedLocationFilter
      this.selectedEmployeeFilter = parseInt(this.$route.query.employeeFilter) || this.selectedEmployeeFilter
      // this.selectedbonusFilter = this.$route.query.bonusFilter || this.selectedbonusFilter
      this.selectedTradeFilter = this.$route.query.tradeFilter || this.selectedTradeFilter

      this.$router.push({
        name: 'month',
        query: this.formattedQuery
      })

      this.getShifts()

      this.positionsLoading = true
      collectionApi.getPositions(positions => {
        this.positionFilters = positions
        this.positionsLoading = false
      },
        error => {
          console.log(error)
          this.positionsLoading = false
        }
      )

      this.locationsLoading = true
      collectionApi.getLocations(locations => {
        this.locationFilters = locations
        this.locationsLoading = false
      },
        error => {
          console.log(error)
          this.locationsLoading = false
        }
      )

      this.employeesLoading = true
      collectionApi.getEmployees(employees => {
        this.employeeFilters = employees
        this.employeesLoading = false
      },
        error => {
          console.log(error)
          this.employeesLoading = false
        }
      )
    },
    shiftIsOnDay: function (shift, day) {
      return this.$moment(shift.startDatetime).isSame(day, 'day')
    },
    eventsOnDate (date) {
      const key = this.$moment(date).format("MM-DD")
      return this.events.filter((e) => this.$moment(e.event_date).format("MM-DD") === key)
    },
    shiftsOnDate: function (date) {
      let dateAsKey = this.$moment(date).format("MM-DD")
      let ordered = {
        assigned: [],
        coordinated: [],
        trade: [],
        available: [],
      }
      var shifts = this.dateMap[dateAsKey]

      if (shifts) {
        shifts.forEach(s => {
          if (s.userId == this.user.id) {
            ordered.assigned.push(s)
          } else if (s.fromCoordinatedCoverageRequestId) {
            ordered.coordinated.push(s)
          } else if ( s.tradePending) {
            ordered.trade.push(s)
          } else if (s.tradePending && ( /* only show the trader and tradee */
            s.tradeAcceptUserId == this.user.id || s.userId == this.user.id
            )
          ) {
            ordered.trade.push(s)
          } else if (!s.userId) {
            ordered.available.push(s)
          }
        })
      }

      return ordered
    },
    shiftCountOnDate: function (date) {
      let shiftsObject = this.shiftsOnDate(date)
      // For all the various shift-type keys in the shiftsOnDate object,
      // sum up all their shifts:
      let count = Object.keys(shiftsObject).reduce((accumulator, item) => {
        return accumulator + shiftsObject[item].length
      }, 0)
      return count;
      /* Because of the way trade shifts are "hidden" in shiftsOnDate, we need
       * to use that same function to get the visible count of shifts on
       * this date. The true fix is refactoring API endpoints for employees to
       * _return_ only the shifts they can see...

      // what used to be here:
      let dateAsKey = this.$moment(date).format("MM-DD")
      let amount = this.dateMap[dateAsKey]
      // need to be careful like this because not all calendar dates will be
      // present in the dateMap table:
      return amount ? amount.length : 0
      */
    },
  },

  data: function() {
    return {
      today: this.$moment().format("YYYY-MM-DD"),
      startDateMenu: false,
      endDateMenu: false,
      beginningOfCurrentMonth: this.$moment()
        .startOf('month')
        .format("YYYY-MM-DD"),
      startDate: this.$moment()
        .startOf('month')
        .format("YYYY-MM-DD"),
      endOfCurrentMonth: this.$moment()
        .endOf('month')
        .format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf('month')
        .format("YYYY-MM-DD"),
      shifts: [],
      events: [],
      shiftQueryPending: false,
      positionsLoading: false,
      locationsLoading: false,
      employeesLoading: false,
      statusFilters: [
        {
          text: 'All',
          value: 'employee-all',
        },
        {
          text: 'Available',
          value: 'available',
        },
        {
          text: 'Mine',
          value: 'assigned',
        },
      ],
      selectedStatusFilter: "employee-all",

      positionFilters: [],
      selectedPositionFilter: null,

      locationFilters: [],
      selectedLocationFilter: null,

      employeeFilters: [],
      selectedEmployeeFilter: null,

      dateMap: {},

      // bonusFilterOptions: [
      //   {
      //     text: 'Straight Bonus',
      //     value: 'straightBonus'
      //   },
      //   {
      //     text: 'Call in Bonus',
      //     value: 'callInBonus'
      //   },
      //   {
      //     text: 'Travel Bonus',
      //     value: 'travelBonus'
      //   }
      // ],
      // selectedbonusFilter: null,
 
      selectedTradeFilter: null,

      

      // selectedMultiFilter: null,
      // selectedMultiFilterClient: null,
      // selectedMultiFilterEmployee: null,
      multiFilterOptions: [
        {
          text: 'By Client',
          value: 'clients',
        },
        {
          text: 'By Employee',
          value: 'employees',
        },
      ],
    }
  },
}
</script>

<style scoped>
#dashboard-container {
}

.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}

.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}

.pending-approval {
  opacity: 0.3;
  border: 1px dashed black !important;
  border-radius: 4px;
  padding: 4px;
}

.shift-overflow-count {
  position: absolute;
  top: 0px;
  right: 0px;
}

</style>

<style>
.vss-calendar.v-calendar.timeframe-week .v-calendar-daily__body {
  display: none !important;
}

.vss-calendar.v-calendar.timeframe-day .v-calendar-daily__body {
  display: none !important;
}

.vss-calendar .v-calendar-weekly__day {
  max-height: 140px !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}

.vss-calendar .v-calendar-weekly__day::-webkit-scrollbar { width: 0 !important; }
.vss-calendar .v-calendar-weekly__day { overflow: -moz-scrollbars-none !important; }
.vss-calendar .v-calendar-weekly__day { -ms-overflow-style: none !important; }

.shift-details-icon {
  cursor: default;
}

.employee-has-shifts {
  opacity: 0.45;
}
</style>
